module.exports = __webpack_public_path__ + "img/stock4.de10fad9.png";